// Fixes the UTC midnight timezone shift bug.
// When JS parses "2024-12-01" it treats it as UTC midnight,
// which rolls back to Nov 30 in EST/CST/etc.
// This function adds the local timezone offset back so the
// date always displays as entered.

export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  // If it's already a full ISO timestamp (has T), parse normally
  if (dateStr.includes('T')) return new Date(dateStr);
  // For date-only strings like "2024-12-01", parse as local time
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}
